import React from "react";

import { SelectField } from "../../../../../../../../../../components/forms/fields";

const options = [
    {
        value: "Link to single result",
        label: "Link to single result"
    },
    {
        value: "Link to seller page",
        label: "Link to seller page"
    },
    {
        value: "Link to next page",
        label: "Link to next page"
    },
    {
        value: "other",
        label: "Other"
    }
];

const NameSelectField = ({ className, name = "name", label = "Name", ...restProps }) => (
    <SelectField
        className={className}
        name={name}
        options={options}
        label={label}
        isMenuPortal
        isRequired
        {...restProps}
    />
);

export default NameSelectField;
